export function getInputUniforms() {
  return `uniform sampler2D input0;
uniform sampler2D input1;`;
}


// WEBPACK FOOTER //
// ./src/lib/shaderGraph/customInput.js